<template>
  <div class="wrapper" ref="mdRef"></div>
</template>

<script>
import { mdRenderData } from "@/utils/markdown/MarkdownConverter";
import morphdom from "morphdom";

export default {
  name: "MarkdownRender",
  props: ["markdown"],
  data() {
    return {
      markdownCache: {},
    };
  },
  mounted() {
    this.updateDOM();
    this.bindImageRetry();
  },
  activated() {
    this.updateDOM();
    this.bindImageRetry();
  },
  beforeDestroy() {
    this.$refs.mdRef?.removeEventListener("error", this.handleImageError, true);
  },
  methods: {
    renderMarkdown() {
      if (!this.markdown || this.markdown === "") return "";
      if (!this.markdownCache[this.markdown]) {
        this.markdownCache[this.markdown] = mdRenderData(this.markdown);
      }
      return this.markdownCache[this.markdown];
    },
    updateDOM() {
      const container = this.$refs.mdRef;
      if (!container) return;

      const newHtml = this.renderMarkdown();
      if (!newHtml) {
        container.innerHTML = "";
        return;
      }

      const temp = document.createElement("div");
      temp.innerHTML = newHtml;

      morphdom(container, temp, {
        childrenOnly: true,
        onBeforeElUpdated: (fromEl, toEl) => {
          if (fromEl.tagName === "DETAILS" && toEl.tagName === "DETAILS") {
            toEl.open = fromEl.open;
          }
        },
      });
    },
    bindImageRetry() {
      const container = this.$refs.mdRef;
      if (!container) return;
      container.removeEventListener("error", this.handleImageError, true);
      container.addEventListener("error", this.handleImageError, true);
    },
    handleImageError(e) {
      const img = e.target;
      if (img.tagName !== "IMG") return;

      const retryKey = "_retryCount";
      if (!img[retryKey]) img[retryKey] = 0;
      if (img[retryKey] >= 10) {
        // img.src = 'fallback.png'; // 最终失败的占位图
        return;
      }

      img[retryKey]++;
      const delay = Math.min(1000 * Math.pow(2, img[retryKey]), 10000);
      setTimeout(() => {
        const url = img.src.replace(/(\?|&)retry=\d+/, "");
        img.src = url + (url.includes("?") ? "&" : "?") + "retry=" + Date.now();
      }, delay);
    },
  },
  watch: {
    markdown(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (oldVal) {
          this.$delete(this.markdownCache, oldVal);
        }
        this.markdownCache[newVal] = mdRenderData(newVal);
        this.updateDOM();
      }
    },
  },
};
</script>